var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIemail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 2.33331H4.66668C2.66668 2.33331 1.33334 3.33331 1.33334 5.66665V10.3333C1.33334 12.6666 2.66668 13.6666 4.66668 13.6666H11.3333C13.3333 13.6666 14.6667 12.6666 14.6667 10.3333V5.66665C14.6667 3.33331 13.3333 2.33331 11.3333 2.33331ZM11.6467 6.39331L9.56001 8.05998C9.12001 8.41331 8.56001 8.58665 8.00001 8.58665C7.44001 8.58665 6.87334 8.41331 6.44001 8.05998L4.35334 6.39331C4.14001 6.21998 4.10668 5.89998 4.27334 5.68665C4.44668 5.47331 4.76001 5.43331 4.97334 5.60665L7.06001 7.27331C7.56668 7.67998 8.42668 7.67998 8.93334 7.27331L11.02 5.60665C11.2333 5.43331 11.5533 5.46665 11.72 5.68665C11.8933 5.89998 11.86 6.21998 11.6467 6.39331Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIemail);
export default __webpack_public_path__ + "static/media/iemail.55e97da2e9f5398e31052a06e7bc0b6e.svg";
export { ForwardRef as ReactComponent };